import { H1Medium as H1MediumStyle } from 'theme/typography';
import { Text, TextProps } from '@mantine/core';
import mergeTextSx from 'components/typography/merge-text-sx';

/**
 * Applies the H1Medium typography style.
 */
export default function H1Medium({ sx, ...props }: TextProps) {
  return <Text {...props} sx={mergeTextSx(H1MediumStyle, sx)} />;
}
